import React, { useCallback, useState } from "react";
import { styled } from "../../../../stitches.config";

import WithLazyLoad from "../../../HOCs/WithLazyLoad";
import AnimateHeightWrapper, { AnimateWrapperButton } from "../../Parts/Brid/common/components/AnimateHeightWrapper";

import ConditionalWrapper from "../../../../helpers/ConditionalWrapper";
import EmbedIframeWrapper from "../../../../helpers/EmbedIframeWrapper";

import shareIcon from "../../../../redesign/assets/icons/socialbutton-share.svg"

const TiktokEmbed = (props) => {

  const [visibility, setVisibility] = useState(false);
  const { profile, videoId, noWrapper } = props;
  const link = "https://www.tiktok.com/" + profile + "/video/" + videoId;

  const handleEmbedLoad = useCallback((tiktokWidgetElement) => {
    const height = tiktokWidgetElement.getBoundingClientRect().height;
    if (height > 450)
      setVisibility(true);
  });

  return (
    <ConditionalWrapper
      condition={!noWrapper}
      wrapper={children => (
        <WithLazyLoad options={{
          height: 300,
          once: true,
          offset: 600
        }}>
          <AnimateHeightWrapper forceCollapse={true} type={AnimateWrapperButton.ShowMore} height={450} visibility={visibility}>
            {children}
          </AnimateHeightWrapper>
        </WithLazyLoad>
      )}
    >
      <CenteredEmbed>
        <EmbedIframeWrapper
          defaultEmbedScripts={"https://www.tiktok.com/embed.js"}
          defaultWindowStyle={`body > div > iframe, body > div > blockquote { margin: 0 auto !important; }`}
          onEmbedLoad={handleEmbedLoad}
        >
          <blockquote
            className="tiktok-embed"
            cite={link}
            data-video-id={videoId}
            style={{ "max-width": "605px", "min-width": "325px;" }}>
            <section>
              <a target="_blank" title={profile} href={"https:www.tiktok.com/" + profile}>{profile}</a>
            </section>
          </blockquote>
        </EmbedIframeWrapper>
      </CenteredEmbed>
    </ConditionalWrapper>
  );

};

export default TiktokEmbed;

const CenteredEmbed = styled("div", {
  textAlign: "center",
  margin: "20px 0px",
  minHeight: "325px",
  position: "relative",
  "&::before": {
    minHeight: "100px",
    height: "100%",
    content: "",
    background: `transparent url("${shareIcon}") no-repeat center center`,
    backgroundSize: "80px",
    opacity: 0.4,
    top: "0",
    left: "0",
    right: "0",
    position: "absolute",
    zIndex: 0
  }
});